import { mockUrl, mock } from 'src/constants/Mock';
import APIS from 'src/constants/ApiConfig';
import HttpService from './HttpService';

const useMock = false;

export const getMallEdiUrl = (url: string) => {
  if (useMock) {
    return mockUrl(mock.mall, url);
  } else {
    return APIS.domainApi(url);
  }
};

export interface IOrderMedicineStatus {
  group: number;
  status: 'PREPARE' | 'SENDING' | 'SUCCESS' | 'FAILED';
  modified_time: string;
  error_code: string;
  error_message: string;
}

export interface IMallEdiResult<T> {
  error_code: string;
  error_message: string;
  order: string;
  created_time: string;
  modified_time: string;
  prescriptions: T;
  status: 'PREPARE' | 'SENDING' | 'SUCCESS' | 'FAILED';
}

export interface IOrderMedicineConfig {
  url: string;
  token: string;
  is_enabled: boolean;
}

export class MallEdiService {
  /**
   * 推送处方
   *
   * @static
   * @param {string} orderUUID
   * @returns {Promise<IOrderMedicineStatus[]>}
   * @memberof MallEdiService
   */
  static async sendOrderMedicine(orderUUID: string): Promise<IOrderMedicineStatus[]> {
    let result: IOrderMedicineStatus[] = [];
    const url = getMallEdiUrl(APIS.mallEdi.sendOrder);
    try {
      const res: IMallEdiResult<IOrderMedicineStatus[]> = await HttpService.post(url, {
        order: orderUUID,
      });
      if (!!res) {
        result = res.prescriptions;
        result.sort((objA, objB) => objA.group - objB.group);
      }
    } catch (error) {
      console.error(error);
    }
    // result = [
    //   {
    //     group: 0,
    //     status: 'ok',
    //     modified_time: '',
    //     error_code: '',
    //     error_message: '',
    //   },
    //   {
    //     group: 1,
    //     status: 'fail',
    //     modified_time: '',
    //     error_code: '',
    //     error_message: '',
    //   },
    // ];
    return result;
  }

  /**
   * 查询推送结果
   *
   * @static
   * @param {string} orderUUID
   * @returns {Promise<IOrderMedicineStatus[]>}
   * @memberof MallEdiService
   */
  static async getSendOrderMedicineResult(orderUUID: string): Promise<IOrderMedicineStatus[]> {
    let result: IOrderMedicineStatus[] = [];
    const url = getMallEdiUrl(APIS.mallEdi.sendOrder);
    try {
      const res: IMallEdiResult<IOrderMedicineStatus[]> = await HttpService.get(`${url}${orderUUID}/`);
      if (!!res) {
        result = res.prescriptions;
        result.sort((objA, objB) => objA.group - objB.group);
      }
    } catch (error) {
      console.error(error);
    }
    // result = [
    //     {
    //       group: 0,
    //       status: 'ok',
    //       modified_time: '',
    //       error_code: '',
    //       error_message: '',
    //     },
    //     {
    //       group: 1,
    //       status: 'ok',
    //       modified_time: '',
    //       error_code: '',
    //       error_message: '',
    //     },
    //   ];
    return result;
  }

  /**
   * 获取推送配置
   *
   * @static
   * @returns {(Promise<IOrderMedicineConfig | undefined>)}
   * @memberof MallEdiService
   */
  static async getSendOrderMedicineConfig(): Promise<IOrderMedicineConfig | undefined> {
    try {
      const url = getMallEdiUrl(APIS.mallEdi.sendConfig);
      return HttpService.get(`${url}`);
    } catch (error) {
      console.error(error);
    }
    return undefined;
  }
}



// WEBPACK FOOTER //
// ./src/services/MallEdiService.ts